import { getNutrimaticApiBaseUrl } from '@/config/nutrimatic'

export type NutrimaticServiceReady = {
  ok: boolean
  status: number
  body: Record<string, unknown>
}

/** Ops probe `GET {apiBaseUrl}/ready` — not a market-data SDK call. */
export async function fetchNutrimaticServiceReady(
  baseUrl: string = getNutrimaticApiBaseUrl(),
): Promise<NutrimaticServiceReady> {
  const res = await fetch(`${baseUrl}/ready`)
  let body: Record<string, unknown> = {}
  try {
    body = (await res.json()) as Record<string, unknown>
  } catch {
    body = {}
  }
  return { ok: res.ok, status: res.status, body }
}
